import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { HelpService } from '~commonInfra/services/HelpService';
import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle } from '../../../../styles/CommonStyles';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForServerAdminProps } from '../../site-settings/ReactSiteSettingsForServerAdmin';

export type CatalogingSectionProps = SiteSettingsForServerAdminProps<'catalogingOnSiteEnabled'>;

export const CATALOGING_FIELD = 'settings.catalogingOnSiteEnabled';

export function CatalogingSection(props: CatalogingSectionProps) {
  const catalogingEnabledOnServer = useSelector(SessionServerSelectors.catalogingOnServerEnabled);

  return (
    catalogingEnabledOnServer
      ? <SettingsSection testId={'cataloging-setting-section'}
                         title={Messages.tableauCatalog()}
                         description={renderDescription()}>

        <FormikCheckbox name={CATALOGING_FIELD}
                        label={Messages.allowCatalogingOnSite()}
                        testId={'allow-cataloging-on-site-checkbox'}/>
      </SettingsSection>

      : null // don't render the section if setting is not enabled on server. React requires returning null in this case
  );
}

function renderDescription() {
  return (
    <div>
      {Messages.catalogingOnSiteDetails()}
      <TextLinkWidget testId={'cataloging-learn-more-link'}
                      target={'_blank'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('catalog-site-setting')}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>
  );
}

export const CatalogingSectionSpecs = componentRegistryEntry({
  name: 'CatalogingSection',
  component: CatalogingSection
});
